import { createApiRef } from '@backstage/core-plugin-api';
import { ExporterJsonResponse, ExporterPlatformResponse } from './types';

/** @public */
export const ApiExporterRef = createApiRef<ApiDefExporterApi>({
  id: 'plugin.api-exporter.service',
});

/** @public */
export interface ApiDefExporterApi {
  getApiDefinition(url: string): Promise<ExporterJsonResponse>;
  getPlatformList(url: string): Promise<ExporterPlatformResponse>;
}
